import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent {

   constructor(private titleService: Title) { }
   
     ngOnInit() {
        this.titleService.setTitle('Terms ann Conditions');
     }
}
